import React from "react";
import CategoryContainer from "../../../Categories";

export default function CategoryPage() {
  return (
    <div className="page-body">
      <CategoryContainer />
    </div>
  );
}
